<xemex-dialog-shell [title]="'alarmsPage.settings.addRecipientsDialog.title' | translate">
  <div class="flex flex-col gap-4">
    <p class="text-sm text-text-secondary">
      {{ 'alarmsPage.settings.addRecipientsDialog.description' | translate }}
    </p>

    <xemex-search-input
      [placeholder]="'alarmsPage.settings.addRecipientsDialog.searchPlaceholder' | translate"
      (valueChange)="query.set($event)"
    ></xemex-search-input>

    <div class="flex items-center justify-between">
      <mat-checkbox
        [checked]="isAllSelected()"
        [disabled]="!filteredCandidates().length"
        (change)="toggleAll()"
      >
        <span class="text-sm font-medium text-text-default">
          {{ 'alarmsPage.settings.addRecipientsDialog.selectAll' | translate }}
        </span>
      </mat-checkbox>
      <span class="text-sm text-brand-primary">
        {{
          (candidates().length === 1
            ? 'alarmsPage.settings.addRecipientsDialog.userAvailable'
            : 'alarmsPage.settings.addRecipientsDialog.usersAvailable'
          ) | translate: { count: candidates().length }
        }}
      </span>
    </div>

    <div class="flex max-h-80 flex-col gap-1 overflow-y-auto">
      @for (candidate of filteredCandidates(); track candidate.id) {
        <mat-checkbox
          class="w-full rounded-lg px-2 py-2 hover:bg-surface-hover"
          [checked]="isSelected(candidate.id)"
          (change)="toggleOne(candidate.id)"
        >
          <span class="flex min-w-0 flex-1 items-center gap-3">
            <span
              class="flex h-8 w-8 flex-none items-center justify-center rounded-full bg-surface-highlight text-sm font-semibold text-brand-primary"
            >
              {{ initial(candidate.name) }}
            </span>
            <span class="flex min-w-0 flex-1 flex-col">
              <span class="truncate text-sm font-medium text-text-default">{{ candidate.name }}</span>
              <span class="truncate text-xs text-text-secondary">{{ candidate.email }}</span>
            </span>
            <xemex-tag state="neutral" [label]="candidate.role"></xemex-tag>
          </span>
        </mat-checkbox>
      } @empty {
        <p class="px-2 py-6 text-center text-sm text-text-muted">{{ 'general.noData' | translate }}</p>
      }
    </div>
  </div>

  <div actions class="flex w-full items-center justify-between gap-4">
    <span class="text-sm font-semibold text-text-secondary">
      {{ 'alarmsPage.settings.addRecipientsDialog.selectedCount' | translate: { count: selectedCount() } }}
    </span>
    <div class="flex items-center gap-3">
      <xemex-text-button type="button" intent="primary" (click)="cancel()">
        {{ 'general.btnCancel' | translate }}
      </xemex-text-button>
      <xemex-filled-button type="button" [disabled]="!selectedCount()" (click)="add()">
        {{ 'alarmsPage.settings.addRecipientsDialog.add' | translate }}
      </xemex-filled-button>
    </div>
  </div>
</xemex-dialog-shell>
